import { Component } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { ContentComponent } from '../content/content.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { TranslateModule } from '@ngx-translate/core';
import { AppFooterComponent } from '../../app-footer/app-footer.component';

@Component({
  selector: 'app-career',
  imports: [
    HeaderComponent,
    ContentComponent,
    MatGridListModule,
    TranslateModule,
    AppFooterComponent,
  ],
  templateUrl: './career.component.html',
  styleUrl: './career.component.scss',
})
export class CareerComponent {}
